__turbopack_context__.v({
  "button": "styles-module__ewUjqq__button",
  "container": "styles-module__ewUjqq__container",
  "containerHidden": "styles-module__ewUjqq__containerHidden",
  "cookiesContainer": "styles-module__ewUjqq__cookiesContainer",
  "description": "styles-module__ewUjqq__description",
  "slidein": "styles-module__ewUjqq__slidein",
});
